module.exports = __webpack_public_path__ + "media/hallBgm.343fbb65.mp3";